import React from 'react';
import { Route } from '../Routing/types';
import { UserMealsPage } from '@front-activerse/modules';
import descendantRoutes from './descendantRoutes';
import mealsNavigation from '../navigation/mealsNavigation';

const routes: Route[] = [
  {
    path: 'meals/user-meals/*',
    element: (
      <UserMealsPage descendantRoutes={descendantRoutes} mealsNavigation={mealsNavigation} />
    ),
    private: true,
    title: 'meals.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
];

export default routes;
